import * as Icons from "react-bootstrap-icons";

const getFileTypeIcon = (value) => {
  if (value.includes(".pdf")) {
    return <Icons.FileEarmarkPdf size={20} />;
  } else if (value.includes(".doc") || value.includes(".docx")) {
    return <Icons.FileEarmarkWord size={20} />;
  } else if (value.includes(".xls") || value.includes(".xlsx")) {
    return <Icons.FileEarmarkExcel size={20} />;
  } else if (value.includes(".ppt") || value.includes(".pptx")) {
    return <Icons.FileEarmarkPpt size={20} />;
  } else if (value.includes(".zip") || value.includes(".rar")) {
    return <Icons.FileEarmarkZip size={20} />;
  } else if (
    value.includes(".jpg") ||
    value.includes(".jpeg") ||
    value.includes(".png")
  ) {
    return <Icons.FileEarmarkImage size={20} />;
  } else {
    return <Icons.FileEarmarkArrowDown size={20} />;
  }
};

export default getFileTypeIcon;
